import { neutral } from '@bloomfieldrobotics/canopy';
import { styled } from '@mui/material';
import {
  axisClasses,
  BarChart,
  BarChartProps,
  barElementClasses,
  chartsGridClasses,
} from '@mui/x-charts';

const VERTICAL_MARGIN = 32 as const;

export const StyledBarChart = styled((props: BarChartProps) => {
  return (
    <BarChart
      layout='horizontal'
      hideLegend
      grid={{ vertical: true }}
      xAxis={[
        {
          tickNumber: 9,
          disableLine: true,
          height: VERTICAL_MARGIN,
        },
      ]}
      margin={{
        left: 0,
        right: 80,
        top: VERTICAL_MARGIN / 2,
        bottom: VERTICAL_MARGIN / 2,
      }}
      {...props}
      height={props.height ? props.height + VERTICAL_MARGIN * 2.25 : 100}
    />
  );
})(({ theme }) => ({
  [`.${axisClasses.root}`]: {
    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
      stroke: neutral[750],
      strokeWidth: 1,
    },
  },
  [`& .${chartsGridClasses.line}`]: {
    stroke: neutral[750],
    strokeWidth: 1,
  },
  [`.${axisClasses.directionX}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: theme.vars.palette.text.secondary,
    },
  },
  [`.${barElementClasses.root}`]: {
    stroke: theme.vars.palette.background.paper,
    strokeWidth: 1,
  },
}));
